import router from "../router";
import NProgress from "nprogress";
import Store from "../store";

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  next()
})

router.afterEach(async (to, from, next) => {
  NProgress.done();
  window.scrollTo(0, 0);
});


function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  var context = "";
  if (r != null) { context = r[2]; }
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined" ? "" : context;
}
